import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import HeadingCover from "../../../components/text/heading-cover/heading-cover"
import CardsCarousel from "../../../components/cards-carousel/cards-carousel"
import Heading from "../../../components/text/heading/heading"
import BodyText from "../../../components/text/body-text/body-text"
import * as styles from './index.module.css'

const commonImageProps = {
  layout: "constrained",
  placeholder: "blurred",
  formats: ["auto", "webp"],
  outputPixelDensities: [0.5, 0.75, 1, 2],
}

export const RecognizedExcellence = () => {
  const RecognizedExcellenceData = [
    {
      key: "1",
      image: (
        <StaticImage
          src="../../../images/index/recognizedExcellence/Image 9.png"
          alt="ET NOW logo"
          {...commonImageProps}
          className={styles.excellenceImage}
        />
      ),
      title: "ET NOW",
      description:
        "Best Skill Development Company 2020 Innovation in CSR Practices 2019",
    },
    {
      key: "2",
      image: (
        <StaticImage
          src="../../../images/index/recognizedExcellence/Image-9.png"
          alt="Soch logo"
          {...commonImageProps}
          className={styles.excellenceImage}
        />
      ),
      title: "Soch",
      description:
        "Gold for Vocational Training 2020 Silver for Training of Trainers 2020",
    },
    {
      key: "3",
      image: (
        <StaticImage
          src="../../../images/index/recognizedExcellence/1656312317Logo.png...png"
          alt="Automotive Skills Development Council logo"
          {...commonImageProps}
          className={styles.excellenceImage}
        />
      ),
      title: "Automotive Skills Development Council logo (ASDC)",
      description: "Training Partner Excellence Award 2021 & 2022",
    },
    {
      key: "4",
      image: (
        <StaticImage
          src="../../../images/index/recognizedExcellence/thsc_logoss1.png"
          alt="Tourism & Hospitality Skill Council logo (THSC)"
          {...commonImageProps}
          className={styles.excellenceImage}
        />
      ),
      title: "Tourism & Hospitality Skill Council",
      description:
        "Most Innovative Project in Entrepreneurship Development in Homestay, 2022",
    },
  ]
  return (
    <>
      <HeadingCover className="px-4 text-center mb-8 mx-auto">
        <span>Recognized</span> Excellence In <span>Skill Development</span>
      </HeadingCover>

        <div className="container mx-auto">
        <CardsCarousel
            carouselSettingsOverride={{
              slidesToScroll: 1,
              slidesToShow: 4,
              autoplay: true,
              autoplaySpeed: 5000,
              infinite:
                (RecognizedExcellenceData.length ||
                  0) > 4,
              dots:
                (RecognizedExcellenceData.length ||
                  0) > 4,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots:
                      (RecognizedExcellenceData?.length || 0) > 3,
                    infinite:
                      (RecognizedExcellenceData?.length || 0) > 3,
                  },
                },
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots:
                      (RecognizedExcellenceData?.length || 0) > 2,
                    infinite:
                      (RecognizedExcellenceData?.length || 0) > 2,
                  },
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:
                      (RecognizedExcellenceData?.length || 0) > 1,
                    infinite:
                      (RecognizedExcellenceData?.length || 0) > 1,
                  },
                },
              ],
            }}
          >
            {RecognizedExcellenceData.map(item => (
              <div key={item.key} className="h-full py-1">
                <div
                  className={`p-4 text-center flex flex-col my-2 mx-4 rounded-2xl  h-full bg-white shadow-[0px_2px_10px_#00000029]`}
                >
                  <div className="flex justify-center items-center bg-gray-100 w-full py-2 h-36 ">
                    {item.image}
                  </div>
                  <Heading variant="h5" className={`mt-3  `}>
                    {item.title}
                  </Heading>
                  <BodyText
                    variant="bodyText7"
                    className="text-center text-balance mt-auto mb-2"
                  >
                    {item.description}
                  </BodyText>
                </div>
              </div>
            ))}
          </CardsCarousel>
        </div>
    </>
  )
}
